
const SklHotelCard = () => {
  return (
    <>
      {
        Array.from({ length: 5 }).map((_, i) => (
          <div className='skl-hotel-card' key={i}>
            <div className='left skeleton'></div>
            <div className='center'>
              <div className='skl-pr1 skeleton mb-1'></div>
              <div className='skl-pr2 skeleton w-60 d-inline-block'></div>
              <div className='flex mt-2 mb-2'>
                <div className='skl-pr1 skeleton w-10 mr-1'></div>
                <div className='skl-pr1 skeleton w-10 mr-1'></div>
                <div className='skl-pr1 skeleton w-10 mr-1'></div>
                <div className='skl-pr1 skeleton w-10 mr-1'></div>
                <div className='skl-pr1 skeleton w-10 mr-1'></div>
                <div className='skl-pr1 skeleton w-10 mr-1'></div>
                <div className='skl-pr1 skeleton w-10 mr-1'></div>
                <div className='skl-pr1 skeleton w-10 mr-1'></div>
              </div>
              <div className='skl-pr2 skeleton mb-2'></div>
              <div className='flex'>
                <div className='skl-pr1 skeleton w-20 mr-1'></div>
                <div className='skl-pr1 skeleton w-20 mr-1'></div>
              </div>
            </div>
            <div className='right skeleton'></div>
          </div>
        ))
      }
    </>
  )
}

export default SklHotelCard